module.exports = __webpack_public_path__ + "res/15-img_card_bg.8da7a64259fe8bc2f4a5c482ac3daaf0.png";